import {
  WSFlexBox,
  WSIcon,
  WSText,
  toWSDateString
} from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  InvoiceStatus,
  PayoutPreferences
} from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { addDays } from "date-fns";
import { Tooltip } from "../../../components/Tooltip";
import {
  getIsInvoiceAccepted,
  getIsInvoiceCreator,
  getIsInvoiceRejected,
  getIsInvoiceResubmitted
} from "../../../query/payments/selectors";
import { addBusinessDays, isSameDate } from "../../../utils/dates";

type Props = {
  invoice: IInvoice;
};

export const InvoiceRecentUpdate: React.FC<Props> = ({ invoice }) => {
  return invoice.status === InvoiceStatus.Draft ? (
    isSameDate(invoice.createdAt, invoice.updatedAt) ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Created {toWSDateString(invoice.createdAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : (
      <WSText.ParagraphXs color="gray500" align="right">
        Last updated {toWSDateString(invoice.updatedAt, "monthDate")}
      </WSText.ParagraphXs>
    )
  ) : invoice.status === InvoiceStatus.Paid ? (
    invoice.events.depositedAt ? (
      <WSText.ParagraphXs color="gray500" align="right">
        {formatMoney(
          Math.abs(invoice.amountDetails?.memberGross || 0),
          invoice.currency
        )}{" "}
        payout initiated on{" "}
        {toWSDateString(invoice.events.depositedAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : invoice.events.instantPayoutAt ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Deposited instantly on{" "}
        {toWSDateString(invoice.events.instantPayoutAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : invoice.member.payoutPreferences === PayoutPreferences.Instant ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Expected instant deposit {toWSDateString(new Date(), "monthDate")}
      </WSText.ParagraphXs>
    ) : invoice.amountDetails ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Payout initiated on{" "}
        {toWSDateString(invoice.events.estimatedDepositAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : (
      <WSText.ParagraphXs color="gray500" align="right">
        Paid outside of Wingspan on{" "}
        {toWSDateString(invoice.events.paidAt, "monthDate")}
      </WSText.ParagraphXs>
    )
  ) : invoice.status === InvoiceStatus.PaymentInTransit ? (
    <WSText.ParagraphXs color="gray500" align="right">
      Waiting on client's wire transfer to arrive
    </WSText.ParagraphXs>
  ) : getIsInvoiceRejected(invoice) ? (
    <Tooltip
      trigger={
        <WSFlexBox.CenterY>
          <WSText.ParagraphXs color="gray500" align="right">
            Client rejected invoice
          </WSText.ParagraphXs>
          <WSIcon block name="info-circle" size="XS" color="gray500" ml="XS" />
        </WSFlexBox.CenterY>
      }
    >
      <WSText.ParagraphXs color="white">Reject comment:</WSText.ParagraphXs>
      <WSText.ParagraphXs color="white">
        {invoice.client.comment}
      </WSText.ParagraphXs>
    </Tooltip>
  ) : getIsInvoiceResubmitted(invoice) ? (
    <WSText.ParagraphXs color="gray500" align="right">
      Client resolved dispute at{" "}
      {toWSDateString(invoice.events.clientResolvedDisputeAt, "monthDate")}
    </WSText.ParagraphXs>
  ) : invoice.status === InvoiceStatus.Pending ? (
    <WSText.ParagraphXs color="gray500" align="right">
      Invoice is pending
    </WSText.ParagraphXs>
  ) : invoice.status === InvoiceStatus.Open ? (
    addDays(new Date(), 3) > invoice.dueDate &&
    getIsInvoiceCreator(invoice, invoice.memberId) ? (
      <WSText.ParagraphXs color="amber400" align="right">
        Due soon ({toWSDateString(invoice.dueDate, "monthDate")})
      </WSText.ParagraphXs>
    ) : invoice.events.emailViewedAt &&
      invoice.events.emailViewedAt.length > 0 ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Last viewed{" "}
        {toWSDateString(
          invoice.events.emailViewedAt[invoice.events.emailViewedAt.length - 1],
          "monthDate"
        )}
      </WSText.ParagraphXs>
    ) : getIsInvoiceAccepted(invoice) ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Accepted by you on{" "}
        {toWSDateString(invoice.events.memberAcceptedAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : (
      <WSText.ParagraphXs color="gray500" align="right">
        Sent {toWSDateString(invoice.events.openedAt, "monthDate")}
      </WSText.ParagraphXs>
    )
  ) : getIsInvoiceAccepted(invoice) ? (
    <WSText.ParagraphXs color="gray500" align="right">
      Accepted by you on{" "}
      {toWSDateString(invoice.events.memberAcceptedAt, "monthDate")}
    </WSText.ParagraphXs>
  ) : invoice.status === InvoiceStatus.Overdue ? (
    <WSText.ParagraphXs color="red400" align="right">
      Overdue ({toWSDateString(invoice.dueDate, "monthDate")})
    </WSText.ParagraphXs>
  ) : null;
};
